if (!customElements.get('spk-scope-dusk')) {
  customElements.define('spk-scope-dusk', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.variants = JSON.parse(this.querySelector('[data-dusk-variants]').textContent);
      this.scope = this.closest('[data-section-type]') || this.closest('.shopify-section') || document;
      this.wrapper = this.closest('.product__custom-code');
      this.trigger = this.querySelector('[data-dusk-open]');
      this.drawer = this.querySelector('dialog');
      this.phase = this.querySelector('[data-dusk-usp-phase]').content.textContent;
      this.phaseII = this.querySelector('[data-dusk-usp-phase-ii]').content.textContent;
      document.body.appendChild(this.drawer);
      this.trigger.addEventListener('click', () => this.openDrawer(), {signal});
      this.drawer.querySelectorAll('[data-dusk-close]').forEach(button => {
        button.addEventListener('click', () => this.drawer.close(), {signal});
      });
      this.drawer.addEventListener('click', event => {
        const rect = this.drawer.getBoundingClientRect();
        if (event.target === this.drawer && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.drawer.close();
      }, {signal});
      this.drawer.addEventListener('close', () => this.restorePage(), {signal});
      this.scope.addEventListener('change', () => this.paint(), {signal});
      document.addEventListener('variant:change', event => {
        if (this.scope.contains(event.target)) this.paint(event.detail?.variant?.id);
      }, {signal});
      window.addEventListener('popstate', () => this.paint(new URLSearchParams(location.search).get('variant')), {signal});
      this.paint(this.dataset.initialVariant);
      requestAnimationFrame(() => this.paint());
    }
    currentVariant() {
      const selected = Array.from(this.scope.querySelectorAll('fieldset input[type="radio"]:checked, select[name^="options"]')).map(input => input.value);
      const match = Object.entries(this.variants).find(([, variant]) => variant.options.every(option => selected.includes(option)));
      if (match) return match[0];
      return this.scope.querySelector('form[action*="/cart/add"] [name="id"]')?.value || this.dataset.initialVariant;
    }
    paint(id) {
      const variant = this.variants[id || this.currentVariant()];
      const isDusk = !!variant && /\bDUSK\b/i.test(variant.title);
      this.hidden = !isDusk;
      if (this.wrapper) this.wrapper.hidden = !isDusk;
      this.scope.querySelectorAll('.spk-skiusp li').forEach(item => {
        if (/photochrom/i.test(item.textContent)) item.textContent = isDusk ? this.phaseII : this.phase;
      });
      if (!isDusk && this.drawer.open) this.drawer.close();
    }
    openDrawer() {
      if (this.hidden || this.drawer.open) return;
      this.pageOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.drawer.showModal();
      this.trigger.setAttribute('aria-expanded', 'true');
    }
    restorePage() {
      if (this.pageOverflow !== undefined) {
        document.documentElement.style.overflow = this.pageOverflow;
        this.pageOverflow = undefined;
      }
      this.trigger.setAttribute('aria-expanded', 'false');
      if (this.isConnected && !this.hidden) this.trigger.focus({preventScroll: true});
    }
    disconnectedCallback() {
      this.restorePage();
      this.controller?.abort();
      this.drawer?.remove();
      this.controller = null;
    }
  });
}
